// Should stay in sync with tasksDueNotificationTypes.mjs

export const TASKS_DUE_NOTIFICATION_TYPES = {
  OBSERVATION_REPORT: 0
};
